'use strict'

module.exports = { version: '9.3.2' }
